import { useState, useEffect, useCallback } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import CircularProgress from '@mui/material/CircularProgress'
import Page from '../../shared/components/layouts/Page'
import PageHeader from '../../shared/components/layouts/PageHeader'
import PageBody from '../../shared/components/layouts/PageBody'
import PageSection from '../../shared/components/layouts/PageSection'
import PageSectionRow from '../../shared/components/layouts/PageSectionRow'
import Flex from '../../shared/components/layouts/Flex'
import useCurrentUser from '../../shared/resources/api/v1/auth/useCurrentUser'
import TwoFactorSection from './TwoFactorSection'

const UserSettingsPage = () => {
  const intl = useIntl()
  const { get } = useCurrentUser()
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchUser = useCallback(() => {
    return get()
      .then(({ user: userData }) => {
        setUser(userData)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [get])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  if (loading) {
    return (
      <Page>
        <PageHeader title={<FormattedMessage id="settings.title" />} />
        <PageBody>
          <Flex justifyContent="center" fullWidth>
            <CircularProgress />
          </Flex>
        </PageBody>
      </Page>
    )
  }

  return (
    <Page>
      <PageHeader title={<FormattedMessage id="settings.title" />} />
      <PageBody>
        <PageSection
          titleId="settings.profile.title"
          subtitleId="settings.profile.subtitle"
        >
          <PageSectionRow
            labelId="settings.profile.email"
            value={user.email}
          />
          <PageSectionRow
            labelId="settings.profile.firstName"
            value={user.firstName}
          />
          <PageSectionRow
            labelId="settings.profile.lastName"
            value={user.lastName}
          />
          <PageSectionRow
            labelId="settings.profile.createdAt"
            value={intl.formatDate(user.createdAt, { year: 'numeric', month: 'long', day: 'numeric' })}
          />
        </PageSection>

        <PageSection
          titleId="settings.twoFactor.title"
          subtitleId="settings.twoFactor.subtitle"
        >
          <TwoFactorSection
            otpEnabled={user.otpEnabled}
            onStatusChange={fetchUser}
          />
        </PageSection>
      </PageBody>
    </Page>
  )
}

export default UserSettingsPage
